import pick from 'lodash/pick';
import { createSelector } from 'reselect';
import { getQueryParams } from 'store/router/routerSelectors/getQueryParams';
import { createSearchQuerySelector } from 'lib/search/createQuerySelector';
import { ALLOWED_DEALS_QUERY_PARAMS } from 'config';

// Please try to avoid using this selector directly when you could be using
// one or more of the specific selectors below. Subscribing to the whole query
// tends to result in unnecessary re-renders when only a single query attribute changes.
export const getQuery = createSearchQuerySelector(getQueryParams);

// the following are all prefixed with getQuery to distinguish them from similar named
// selectors that come from the search results
export const getQueryLocation = createSelector(getQuery, (query) => query.location);
export const getQueryPayWith = createSelector(getQuery, (query) => query.payWith);
export const getQueryCheckIn = createSelector(getQuery, (query) => query.checkIn);
export const getQueryCheckOut = createSelector(getQuery, (query) => query.checkOut);
export const getQueryAdults = createSelector(getQuery, (query) => query.adults);
export const getQueryChildren = createSelector(getQuery, (query) => query.children);
export const getQueryInfants = createSelector(getQuery, (query) => query.infants);
export const getQuerySortBy = createSelector(getQuery, (query) => query.sortBy);
export const getQueryPropertyTypes = createSelector(getQuery, (query) => query.propertyTypes);
export const getQueryMinPrice = createSelector(getQuery, (query) => query.minPrice);
export const getQueryMaxPrice = createSelector(getQuery, (query) => query.maxPrice);
export const getQueryMinStarRating = createSelector(getQuery, (query) => query.minStarRating);
export const getQueryMinTripadvisorRating = createSelector(getQuery, (query) => query.minTripadvisorRating);
export const getQuerySearchType = createSelector(getQuery, (query) => query.searchType);
export const getQueryFacilities = createSelector(getQuery, (query) => query.facilities);
export const getQueryFreeCancellation = createSelector(getQuery, (query) => query.freeCancellation);
export const getQueryDepositPay = createSelector(getQuery, (query) => query.depositPay);
export const getQueryPage = createSelector(getQuery, (query) => query.page);
export const getQueryNeLat = createSelector(getQuery, (query) => query.neLat);
export const getQuerySwLat = createSelector(getQuery, (query) => query.swLat);
export const getQueryNeLng = createSelector(getQuery, (query) => query.neLng);
export const getQuerySwLng = createSelector(getQuery, (query) => query.swLng);
export const getQueryFeaturedPropertyId = createSelector(getQuery, (query) => query.featuredPropertyId);
export const getQueryUtmCampaign = createSelector(getQuery, (query) => query.utm_campaign);
export const getQueryUtmSource = createSelector(getQuery, (query) => query.utm_source);
export const getQueryClassicRewards = createSelector(getQuery, (query) => query.classicRewards);
export const getQuerySubRegions = createSelector(getQuery, (query) => query.subRegions);
export const getLocationDealsQuery = createSelector(getQuery, (query) => pick(query, ALLOWED_DEALS_QUERY_PARAMS));
